import { m8API } from 'services/production/m8';
import { GetExchangeRateService } from 'types/services';
import { UnexpectedError } from 'utils/errors';

export const getExchangeRate: GetExchangeRateService = async ({
  date,
  currencyFrom,
  currencyTo,
}) => {
  const m8RateDTO = await m8API.admin.getRateOn({
    rateDate: date,
    currencyFrom,
    currencyTo,
  });

  if (!m8RateDTO) {
    throw new UnexpectedError();
  }

  return m8RateDTO;
};
